import { call, select } from 'redux-saga/effects';
import { sendLog } from '@siteground/styleguide';
import { getImpulseURLs } from '../../selectors/chat-session';
import { getChatMessages } from '../../selectors/messages';
import { shuffleArray } from '../utils/seeded-random';
import { fetchChatMessages } from '../api/messages';

export function* onMessageConsistencyCheck({ action, visitorToken }) {
  const messages = yield select(getChatMessages);
  const IMPULSE_URLS = yield select(getImpulseURLs);
  const { messageActionLogReducer } = yield select();
  const shuffledImpulseUrls = shuffleArray(IMPULSE_URLS);

  if (!visitorToken) {
    return;
  }

  const response = yield call(fetchChatMessages, { wsApi: shuffledImpulseUrls[0], visitorToken });

  if (!response || !response.data) {
    return;
  }

  const { messages: dbMessages, base_operator_id, request_id, status, is_chat_in_progress } = response.data;

  if (dbMessages && dbMessages.length !== messages.length) {
    sendLog({
      uid: 'chat',
      error: 'Inconsistency in chat messages',
      errorInfo: {
        componentStack: ''
      },
      data: JSON.stringify({
        url: window.location.href,
        agent: window.navigator.userAgent,
        base_operator_id,
        request_id,
        status,
        is_chat_in_progress,
        dbMessages,
        feMessages: messages,
        actionTriggeredConsistencyCheck: action && action.type,
        messageActionLogReducer: messageActionLogReducer.slice(
          messageActionLogReducer.length - 20,
          messageActionLogReducer.length
        )
      })
    });
  }
}
